
import {markRaw, PropType} from 'vue';
import {Page} from '../../src/Entity/Page';
import FilterPanel from './Component/Panel.vue';
import TextFilterComponent from './Element/Text/Filter.vue';
import ChoiceFilterComponent from './Element/Choice/Filter.vue';
import DateTimeFilterComponent from './Element/DateTime/Filter.vue';
import { FilterInterface, Filters } from "../../src/Entity/Filter";

const body = document.querySelector('body');
const FILTER_COMPONENTS = [
    TextFilterComponent,
    ChoiceFilterComponent,
    DateTimeFilterComponent,
];

export default {
    components: {FilterPanel},
    props: {
        filters: {
            type: Object as PropType<Filters>,
        }
    },
    emits: ['apply', 'reset'],
    methods: {
        onOpen(): void {
            this.$refs.panel.toggle();
        },
        onApply(filters: Filters) {
            this.$emit('apply', filters);
            this.$refs.panel.toggle();
        },
        onReset() {
            this.$emit('reset');
            this.$refs.panel.toggle();
        },
        support(component: any, filter: FilterInterface): boolean {
            if (Array.isArray(component.expose) && component.expose.includes('support')) {
                return component.methods.support(filter);
            }
            return false;
        }
    },
    data() {
        const filterComponents = [];
        for (const filter of this.filters) {
            for (const component of FILTER_COMPONENTS) {
                if (this.support(component, filter)) {
                    const _component = markRaw(component);
                    filterComponents.push({component: _component, attr: {filter}})
                }
            }
        }
        return {
            filterComponents: filterComponents,
        }
    },
};
